import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#0078FF',
    },

    // st1: {
    //     fill: '#00D7FF',
    // },

    st2: {
        fill: '#010134',
    },

    st3: {
        fill: '#FFFFFF',
    },

    st4: {
    },

    st5: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st6: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
